import { useContext } from "react";
import { useQuery } from "@tanstack/react-query"

import { LanguageContext } from "../i18n/LanguageProvider"
import { fetchJobById } from "../services/utils/fetch"

const MAX_TRIES = 100;

export const useFetchJobById = ({ id, enabled, callback, onMaxRetryCallback }) => {
  const { language } = useContext(LanguageContext);

  return useQuery({
    queryKey: ["job", id, language],
    queryFn: () => fetchJobById(id, callback),
    enabled,
    retry: (failedCount) => {
      if (failedCount >= MAX_TRIES) {
        onMaxRetryCallback?.()
        return false;
      }
      return true;
    },
    retryDelay: 3_000, // 3 second
    refetchOnMount: enabled,
    staleTime: 3_600_000, // 1 hour,
    refetchOnWindowFocus: enabled,
    refetchOnReconnect: enabled,
  });
}
